/* ============================================================
   MindPixels — Popups (3)

   1. mpPopupBuy      — imagen del kit. Abre con [data-popup="buy"].
   2. mpPopupRetain   — imagen de la caja. Timer / exit-intent / scroll final.
   3. mpPopupShipping — tiempos de entrega. Es el ÚLTIMO PASO antes del carrito.

   Flujo de intención de compra:
     click en imagen del popup 1 o 2  ─┐
     submit del form de la PDP        ─┴─► popup de tiempos de entrega
                                              │
                                   ┌──────────┴──────────┐
                            "Aceptar y continuar"    cerrar (X / fondo / ESC)
                                   │                     │
                            se ejecuta la acción     se CANCELA la compra
   ============================================================ */
(function () {
  'use strict';

  var retainShown = false;
  var retainTimer = null;

  var retainEl = document.querySelector('.mp-popup--retain');
  var timerSeconds = parseInt((retainEl && retainEl.dataset.timer) || '30', 10);

  // Acción pendiente de confirmar en el popup de tiempos de entrega.
  var pendingAction = null;

  // ============================================
  // HELPERS
  // ============================================
  function openPopup(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('aria-hidden', 'false');
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    el.classList.remove('is-open');
    if (!document.querySelector('.mp-popup.is-open')) {
      document.body.style.overflow = '';
    }
  }

  function showRetain() {
    if (retainShown) return;
    // No lo abrimos encima de otro popup ya abierto
    if (document.querySelector('.mp-popup.is-open')) return;
    retainShown = true;
    clearTimeout(retainTimer);
    openPopup('mpPopupRetain');
  }

  // ============================================
  // INTENCIÓN DE COMPRA → popup de tiempos de entrega
  // ============================================

  /* Registra la acción y pide confirmación. La acción SOLO se ejecuta si el
     usuario pulsa "Aceptar y continuar"; si cierra el popup, se descarta. */
  function requestPurchase(action) {
    pendingAction = action;
    closePopup('mpPopupBuy');
    closePopup('mpPopupRetain');
    openPopup('mpPopupShipping');
  }

  function acceptPurchase() {
    var action = pendingAction;
    pendingAction = null;
    closePopup('mpPopupShipping');
    if (typeof action === 'function') action();
  }

  function cancelPurchase() {
    pendingAction = null; // cerrar sin aceptar cancela la compra
    closePopup('mpPopupShipping');
  }

  // ============================================
  // ADD TO CART — caja con selling plan (preorder)
  // ============================================
  var BOX_VARIANT_ID = 54455151132977;
  var BOX_SELLING_PLAN = 692435288369;

  /* Añade la caja al carrito y solo entonces redirige.

     El selling_plan de preorder SOLO está publicado para el mercado US. Desde
     otros mercados Shopify NO devuelve error: responde 200 con `{"items":[]}`,
     o sea, no añade nada. El código anterior redirigía en el `.then()` sin
     mirar la respuesta y el visitante aterrizaba en un carrito vacío.

     Aquí comprobamos que la respuesta trae líneas y, si no, reintentamos sin
     el selling_plan. En US la compra entra como preorder ($59.99); fuera de US
     entra como venta normal, pero no se pierde. Ver SPEC.md §4.0-C y §9. */
  function postCartAdd(payload) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().catch(function () { return null; });
    });
  }

  function addedOk(data) {
    if (!data) return false;
    if (Array.isArray(data.items)) return data.items.length > 0;
    return Boolean(data.id); // respuesta de línea única
  }

  function addBoxToCartAndRedirect() {
    var withPlan = { items: [{ id: BOX_VARIANT_ID, quantity: 1, selling_plan: BOX_SELLING_PLAN }] };
    var withoutPlan = { items: [{ id: BOX_VARIANT_ID, quantity: 1 }] };

    postCartAdd(withPlan)
      .then(function (data) {
        if (addedOk(data)) return true;
        // El selling_plan fue rechazado en silencio: reintentar sin él.
        return postCartAdd(withoutPlan).then(addedOk);
      })
      .catch(function () {
        return postCartAdd(withoutPlan).then(addedOk).catch(function () { return false; });
      })
      .then(function () { window.location.href = '/cart'; });
  }

  // Click en la imagen del popup de compra → confirmar entrega → carrito
  document.addEventListener('click', function (e) {
    var imgLink = e.target.closest('.mp-popup__buy-img-link');
    if (imgLink) {
      e.preventDefault();
      requestPurchase(addBoxToCartAndRedirect);
    }
  });

  // Click en la imagen del popup de retención → mismo flujo
  var retainImg = document.getElementById('mpRetainImg');
  if (retainImg) {
    retainImg.addEventListener('click', function () {
      requestPurchase(addBoxToCartAndRedirect);
    });
  }

  // ============================================
  // PDP — interceptar el "añadir al carrito"
  // ============================================
  /* Interceptamos el SUBMIT del formulario (no el click del botón): así
     funciona tanto con nuestro botón como con el que inyecta la app de
     preorder, que envía el mismo form. */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener(
      'submit',
      function (e) {
        if (productForm.dataset.mpConfirmed === '1') return; // ya aceptado: dejar pasar
        e.preventDefault();
        e.stopPropagation();
        requestPurchase(function () {
          productForm.dataset.mpConfirmed = '1';
          if (typeof productForm.requestSubmit === 'function') {
            productForm.requestSubmit();
          } else {
            productForm.submit();
          }
        });
      },
      true // captura: nos adelantamos a los listeners de la app de preorder
    );
  }

  // ============================================
  // POPUP COMPRA — botones con data-popup="buy"
  // ============================================
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-popup="buy"], .mp-trigger-buy');
    if (trigger) {
      e.preventDefault();
      openPopup('mpPopupBuy');
    }
  });

  // ============================================
  // CIERRES
  // ============================================
  function bindClose(id, popupId) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('click', function () { closePopup(popupId); });
  }

  bindClose('mpPopupBuyClose', 'mpPopupBuy');
  bindClose('mpPopupBuyBackdrop', 'mpPopupBuy');
  bindClose('mpPopupRetainClose', 'mpPopupRetain');
  bindClose('mpPopupRetainBackdrop', 'mpPopupRetain');

  // El popup de entrega, al cerrarse, CANCELA la compra pendiente
  var shipClose = document.getElementById('mpPopupShippingClose');
  var shipBackdrop = document.getElementById('mpPopupShippingBackdrop');
  var shipAccept = document.getElementById('mpShipAccept');

  if (shipClose) shipClose.addEventListener('click', cancelPurchase);
  if (shipBackdrop) shipBackdrop.addEventListener('click', cancelPurchase);
  if (shipAccept) shipAccept.addEventListener('click', acceptPurchase);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (document.getElementById('mpPopupShipping').classList.contains('is-open')) {
      cancelPurchase();
      return;
    }
    closePopup('mpPopupBuy');
    closePopup('mpPopupRetain');
  });

  // ============================================
  // TRIGGERS DEL POPUP DE RETENCIÓN
  // ============================================

  // 1. Timer
  retainTimer = setTimeout(showRetain, timerSeconds * 1000);

  // 2. Exit intent
  document.addEventListener('mouseleave', function (e) {
    if (e.clientY <= 10) showRetain();
  });

  // 3. Scroll hasta el final
  window.addEventListener(
    'scroll',
    function () {
      if (retainShown) return;
      var scrolled = window.scrollY + window.innerHeight;
      var docHeight = document.documentElement.scrollHeight;
      if (scrolled >= docHeight - 60) showRetain();
    },
    { passive: true }
  );
})();
